import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Routes } from 'config';

import { Button } from '../button';

import { GetStartedButtonProps } from './types';

export const GetStartedButton = ({
  children,
  to = Routes.GetStarted.Home,
  ...props
}: GetStartedButtonProps) => {
  const { t } = useTranslation(['common']);

  return (
    <Button to={to} component={Link} buttonClassName="px-5" {...props}>
      {children || t('getStarted')}
    </Button>
  );
};
